<script lang="ts">import ArrowAngled from './Icons/ArrowAngled.svelte';
import ArrowDown from './Icons/ArrowDown.svelte';
import Plus from './Icons/Plus.svelte';
import Video from './Icons/Video.svelte';
const { variant } = $props();
const actionIconMap = {
    // button and button-alt can only have the Plus icon because of the logic in Action's finalVariant and renderIcon
    // variables
    button: Plus,
    'button-alt': Plus,
    text: ArrowAngled,
    video: Video,
    anchor: ArrowDown,
    modal: Plus,
};
</script>

{#if actionIconMap[variant as NonNullable<ActionProps['variant']>]}
  {@const SvelteComponent = actionIconMap[variant as NonNullable<ActionProps['variant']>]}
  <SvelteComponent />
{/if}
